var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"expand-code-wrapper",on:{"click":function($event){$event.stopPropagation();return _vm.$emit('expand')}}},[_c('span',{ref:"btnText",staticClass:"text"},[_vm._v("查看全部")])])}
var staticRenderFns = []

export { render, staticRenderFns }